"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLegacyContractToCXContract = exports.mapPlanQueryKapiToPlanCX = exports.mapPlanLegacyResponseToPlanCX = void 0;
var date_fns_1 = require("date-fns");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
var supply_points_1 = require("../../../billing/utils/supply-points");
var utils_1 = require("../../utils/utils");
var mapPlanLegacyResponseToPlanCX = function (planData, supplyPointData) {
    var _a, _b, _c, _d;
    var electricity = planData.electricity.map(transformLegacyContractToCXContract);
    var gas = planData.gas.map(transformLegacyContractToCXContract);
    var elecSupplies = supplyPointData.filter(supply_points_1.isActiveElectricitySupply);
    //clocking times should be displayed only for non complex customers i.e. customers with only 1 electricity supply
    if (elecSupplies.length === 1) {
        var elecSupply = elecSupplies[0];
        var tprPeak_1 = (_b = (_a = elecSupply.supplyPointInfo) === null || _a === void 0 ? void 0 : _a.registers.find(function (x) { var _a; return ((_a = x.timeOfUseLabel) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'peak'; })) === null || _b === void 0 ? void 0 : _b.timePatternRegime;
        var tprOffpeak_1 = (_d = (_c = elecSupply.supplyPointInfo) === null || _c === void 0 ? void 0 : _c.registers.find(function (x) { var _a; return ((_a = x.timeOfUseLabel) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace('_', '')) === 'offpeak'; })) === null || _d === void 0 ? void 0 : _d.timePatternRegime;
        electricity.forEach(function (elec) {
            return elec.unitRates.forEach(function (ur) {
                if (ur.timingCategory
                    ? ur.timingCategory.toLocaleLowerCase() === 'peak'
                    : null) {
                    ur.timePatternRegime = tprPeak_1;
                }
                if (ur.timingCategory
                    ? ur.timingCategory.toLocaleLowerCase().replace('_', '') ===
                        'offpeak'
                    : null) {
                    ur.timePatternRegime = tprOffpeak_1;
                }
            });
        });
    }
    return { electricity: electricity, gas: gas };
};
exports.mapPlanLegacyResponseToPlanCX = mapPlanLegacyResponseToPlanCX;
var mapPlanQueryKapiToPlanCX = function (_a) {
    var accountById = _a.accountById;
    return !accountById
        ? null
        : __assign({}, accountById.contracts.edges.reduce(function (acc, _a) {
            var contract = _a.node;
            if (!contract.cancelled &&
                (0, utils_1.contractIsActiveAt)((0, date_fns_1.startOfToday)(), contract)) {
                acc[(0, utils_1.getContractFuelAsKey)(contract)].push(transformKapiContractToCXContract(contract));
            }
            return acc;
        }, { electricity: [], gas: [] }));
};
exports.mapPlanQueryKapiToPlanCX = mapPlanQueryKapiToPlanCX;
var mapProjectedConsumption = function (supplyPoint) {
    return supplyPoint.energyProjections.edges.reduce(function (result, edge) {
        var projection = edge.node;
        if ('elecProjectedConsumption' in projection) {
            return __spreadArray(__spreadArray([], __read(result), false), __read(projection.elecProjectedConsumption.map(function (elecProjection) {
                return {
                    msn: projection.msn,
                    timingCategory: elecProjection.registerIdentity.timingCategory,
                    consumption: elecProjection.consumption,
                };
            })), false);
        }
        return __spreadArray(__spreadArray([], __read(result), false), [
            {
                msn: projection.msn,
                consumption: projection.gasProjectedConsumption,
            },
        ], false);
    }, []);
};
function transformKapiContractToCXContract(_a) {
    var _b, _c;
    var tariff_nextV1 = _a.tariff_nextV1, contractStartDate = _a.startDate, endDate = _a.endDate, supplyPoint = _a.supplyPoint;
    var mapUnitRate = ((_c = (_b = tariff_nextV1.consumptionChargeRates) === null || _b === void 0 ? void 0 : _b.ratesByTimingCategory) === null || _c === void 0 ? void 0 : _c.map(function (unitRate) {
        return __assign(__assign({}, unitRate), { timingCategory: mapKaPITimingCategoryToCXTimingCategory(unitRate.timingCategory) });
    })) || [];
    return {
        name: tariff_nextV1.name,
        unitRates: mapUnitRate,
        standingCharge: tariff_nextV1.standingRate,
        contractStartDate: contractStartDate,
        contractEndDate: endDate || null,
        contractType: tariff_nextV1.type,
        exitFee: tariff_nextV1.exitFee,
        mpxn: supplyPoint.sprn,
        msn: supplyPoint.meterTechnicalDetails.map(function (info) { return info.meterSerialNumber; }),
        projectedConsumption: mapProjectedConsumption(supplyPoint),
        // TODO: these two fields are no longer computed, however we will need them in the future when we have a need to show the customer their exit fees. Defining as undefined for transparency
        isInRenewal: undefined,
        hasFutureContracts: undefined,
    };
}
function transformLegacyContractToCXContract(data) {
    return {
        name: data.name,
        unitRates: data.unitRates.map(mapLegacyUnitRateToCXUnitRate),
        standingCharge: {
            value: data.standingCharge.amount,
            currency: data.standingCharge.currencyUnit,
        },
        contractStartDate: data.contractStartDate,
        contractEndDate: data.contractEndDate,
        contractType: data.contractType === 'fixed' ? __generated__1.TariffType.Fixed : __generated__1.TariffType.Variable,
        exitFee: {
            value: data.exitFee.amount,
            currency: data.exitFee.currencyUnit,
        },
        mpxn: data.mpxn,
        msn: !!data.msn ? [data.msn] : [],
        projectedConsumption: data.personalProjection
            ? [
                {
                    msn: data.msn,
                    consumption: data.personalProjection.toString(),
                },
            ]
            : [],
        isInRenewal: data.isInRenewal,
        hasFutureContracts: data.hasFutureContracts,
    };
}
exports.transformLegacyContractToCXContract = transformLegacyContractToCXContract;
function mapLegacyUnitRateToCXUnitRate(_a) {
    var name = _a.name, unitRate = _a.unitRate;
    return {
        timingCategory: name === 'day' || name === 'peak'
            ? __generated__1.SupplyPointTimingCategory.Peak
            : name === 'night' || name === 'offpeak'
                ? __generated__1.SupplyPointTimingCategory.OffPeak
                : name === 'heating'
                    ? __generated__1.SupplyPointTimingCategory.Heating
                    : name === 'eveningandweekend' || name === 'evening and weekend'
                        ? __generated__1.SupplyPointTimingCategory.EveningAndWeekend
                        : __generated__1.SupplyPointTimingCategory.Anytime,
        unitRate: {
            value: unitRate.amount,
            currency: unitRate.currencyUnit,
        },
    };
}
function mapKaPITimingCategoryToCXTimingCategory(timingCategory) {
    switch (timingCategory) {
        case 'HEATING':
            return __generated__1.SupplyPointTimingCategory.Heating;
        case 'EVENING_AND_WEEKEND':
            return __generated__1.SupplyPointTimingCategory.EveningAndWeekend;
        case 'OFFPEAK':
            return __generated__1.SupplyPointTimingCategory.OffPeak;
        case 'PEAK':
            return __generated__1.SupplyPointTimingCategory.Peak;
        case 'ANYTIME':
            return __generated__1.SupplyPointTimingCategory.Anytime;
        default:
            return null;
    }
}
